import React from "react";


import {
    SvgIconComponent
} from "@Components/Elements";


import IconSuccessMd from "./@Icons/icon-success-md.svg";
import IconSuccessLg from "./@Icons/icon-success-lg.svg";
import IconInfoMd from "./@Icons/icon-info-md.svg";
import IconInfoLg from "./@Icons/icon-info-lg.svg";
import IconWarningMd from "./@Icons/icon-warning-md.svg";
import IconWarningLg from "./@Icons/icon-warning-lg.svg";
import IconErrorMd from "./@Icons/icon-error-md.svg";
import IconErrorLg from "./@Icons/icon-error-lg.svg";
import IconPauseMd from "./@Icons/icon-pause-md.svg";


import "./index.scss";


type BadgeElementComponentType = 'success' | 'info' | 'warning' | 'error' | 'paused';

type BadgeElementComponentSize = 'md' | 'lg';

interface BadgeElementComponentProps {
    badgeType: BadgeElementComponentType;
    badgeSize: BadgeElementComponentSize;
    badgeText: string;
    badgeIcon?: boolean;
}


type BadgeElementIconsType = {
    [key in BadgeElementComponentType]: {
        [key in BadgeElementComponentSize]: string;
    }
};


const BadgeElementIcons: BadgeElementIconsType = {
    'success': {
        'md': IconSuccessMd,
        'lg': IconSuccessLg,
    },
    'info': {
        'md': IconInfoMd,
        'lg': IconInfoLg,
    },
    'warning': {
        'md': IconWarningMd,
        'lg': IconWarningLg,
    },
    'error': {
        'md': IconErrorMd,
        'lg': IconErrorLg,
    },
    'paused': {
        'md': IconPauseMd,
        'lg': IconPauseMd,
    }
};


export const BadgeElementComponent:React.FC<BadgeElementComponentProps> = ({
    badgeType, badgeSize = 'md', badgeText, badgeIcon = true,
}) => {

    const ElementIcon = BadgeElementIcons[badgeType][badgeSize];

    return (
        <span className={`badge-element-component ${badgeType}-badge-element ${badgeSize}-badge-element`}>
            {badgeIcon && <SvgIconComponent iconSource={ElementIcon} className={'badge-element-icon'} />}
            <span className={'badge-element-text'}>{badgeText}</span>
        </span>
    );

};


export default BadgeElementComponent;
